import { DownloadCreatePayload, Download, DownloadType } from '@/types/index';
import api from '@/utils/api';

export const create = async (payload: DownloadCreatePayload) =>
  api.post<Download>('Downloads/Create', {
    data: payload,
  });

export const list = async (type: DownloadType) => api.get<{ downloadsList: Download[] }>(`Downloads?type=${type}`);

